<div *ngIf="flagLoading">
    <div class="menu">
        <div class="logoBNP">
            <img src="/assets/images/general/logobnpwhite.png" class="logoBNPIMG">
        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-9" oncontextmenu="return false;">

                <!-- <embed [src]="transform(urlDocumental)" width="100%" height="650px" class="embed-responsive-item" 
                type="application/pdf"> -->

                <iframe  oncontextmenu="return false;" [src]="transform(urlDocumental)" class="embed-responsive-item iframe" *ngIf="!flagImagen"
                    type="application/pdf" allowfullscreen ></iframe>

                <div class="embed-responsive-item iframe divScroll" *ngIf="flagImagen" >
                    <p class="text-center">
                        <img src="{{urlDocumental}}" width="100%"> 

                    </p>

                </div>

            </div>
            <div class="col-sm-3">
                <p>
                    <br>
                    <a *ngIf="visorModal.response.list[0].flagDownload=='1'" target="_blank" [href]="urlDocumental" class="btnDownload"> <i class="{{iconDowloand}}"
                            aria-hidden="true"></i> {{botonDowloand}}</a>
                            
                   <span *ngIf="visorModal.response.list[0].flagTranscripcion=='1'"> &nbsp;&nbsp;| &nbsp; </span>
                   <a *ngIf="visorModal.response.list[0].flagTranscripcion=='1'"  href="/assets/transcripcion/{{visorModal.response.list[0].id_documental}}.pdf" download class=""> <i class="fas fa-file-signature"></i>Ver Transcripción</a>

                </p>
                <div class="row divDatosDocumental divScroll">
                    <div class="col-3 mb-3" *ngIf="ftitulo">
                        <span class="font-weight-bold">Título: </span>
                    </div>
                    <div class="col-9 mb-3" *ngIf="ftitulo">
                        {{visorModal.response.list[0].titulo}}
                    </div>
                    <div class="col-3 mb-3" *ngIf="fautor">
                        <span class="font-weight-bold">Autor: </span>
                    </div>
                    <div class="col-9 mb-3" *ngIf="fautor">
                        <span *ngFor="let autor of visorModal.response.list[0].autores">{{autor.nombre}}
                            {{autor.apellidoP}} {{autor.appelidoM}} {{autor.alternativo}}<br></span>
                    </div>
                    <div class="col-3 mb-3" *ngIf="ffechPubli">
                        <span class="font-weight-bold">Fecha de Publicación: </span>
                    </div>
                    <div class="col-9 mb-3" *ngIf="ffechPubli">
                        {{visorModal.response.list[0].fechaPublicacion}}
                    </div>
                    <div class="col-3 mb-3" *ngIf="ftema">
                        <span class="font-weight-bold">Tema: </span>
                    </div>
                    <div class="col-9 mb-3" *ngIf="ftema">
                        <span *ngFor="let tema of visorModal.response.list[0].tema">{{tema.tema}}<br></span>
                    </div>
                    <div class="col-3 mb-3" *ngIf="fdescripcion">
                        <span class="font-weight-bold">Descripción: </span>
                    </div>
                    <div class="col-9 mb-3" *ngIf="fdescripcion">
                        {{visorModal.response.list[0].descripcion}}
                    </div>
                    <div class="col-3 mb-3" *ngIf="ftipo">
                        <span class="font-weight-bold">Tipo: </span>
                    </div>
                    <div class="col-9 mb-3" *ngIf="ftipo">
                        {{visorModal.response.list[0].tipo}}
                    </div>
                    <div class="col-3 mb-3" *ngIf="fnota">
                        <span class="font-weight-bold">Nota: </span>
                    </div>
                    <div class="col-9 mb-3" *ngIf="fnota">
                        {{visorModal.response.list[0].nota}}
                    </div>
                    <div class="col-3 mb-3" *ngIf="flicencia">
                        <span class="font-weight-bold">Licencia: </span>
                    </div>
                    <div class="col-9 mb-3" *ngIf="flicencia">
                        {{visorModal.response.list[0].licencia[0].nombre_largo}}<br>
                        <img src="/assets/images/general/{{visorModal.response.list[0].licencia[0].nombre_imagen}}"
                            width="60%">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>